module.exports = __webpack_public_path__ + "static/media/icon-html.932c06a0.svg";